import React from "react";
import { Flex } from "@emonvia/web-components";
import DataTextFrame from "@/components/DataTextFrame";
import { useOnboarding } from "@/hooks/useOnboarding";
import { useChargePointData } from "@/hooks/useChargePointData";

const ChargePointSection: React.FC = () => {
  const { data } = useOnboarding();
  const cpData = useChargePointData(data);

  return (
    <Flex flexDirection="column" justifyContent="center" gap={16}>
      <DataTextFrame data={cpData} />
    </Flex>
  );
};

export default ChargePointSection;
